import { __decorate } from "tslib";
import { html, attr, when } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/mixin';
import { FoundationElement } from '@microsoft/fast-foundation';
import { uniqueId } from 'lodash-es';
export const cardTemplate = html `
  <template alignment=${(x) => x.alignment} id=${uniqueId('card-')} orientation=${(x) => x.orientation}>
    ${when((x) => x.indicator, html `<span class="indicator"></span>`)}
    <slot></slot>
  </template>
`;
export class CardComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.indicator = false;
        this.selected = false;
        this.orientation = 'vertical';
        this.alignment = 'left';
    }
}
__decorate([
    attr({ mode: 'boolean' })
], CardComponent.prototype, "indicator", void 0);
__decorate([
    attr({ mode: 'boolean' })
], CardComponent.prototype, "selected", void 0);
__decorate([
    attr
], CardComponent.prototype, "orientation", void 0);
__decorate([
    attr
], CardComponent.prototype, "alignment", void 0);
